import { render, staticRenderFns } from "./Meetings.vue?vue&type=template&id=615d1b8c&scoped=true&"
import script from "./Meetings.vue?vue&type=script&lang=ts&"
export * from "./Meetings.vue?vue&type=script&lang=ts&"
import style0 from "./Meetings.vue?vue&type=style&index=0&id=615d1b8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615d1b8c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBreadcrumbs,VBtn,VCard,VDataTable})
